export default {
	debug: state => {
		return process.env.NODE_ENV !== 'production';
	},
};



// WEBPACK FOOTER //
// ./src/store/getters.js